// extracted by mini-css-extract-plugin
module.exports = {"blockTitle":"QuestionsSidebar_blockTitle__T7LXg","listWrap":"QuestionsSidebar_listWrap__1ddnk"};